import ApiService from './api.service.js';
import logger from '@/utils/logger';

class BudgetOverviewService {
  async getFiscalYears(companyId) {
    try {
      const url = `/company/${companyId}/budget-overview/years`;
      const response = await ApiService.get(url);
      const responseData = response.data || response;
      const data = responseData.data || responseData;

      return {
        success: responseData.success !== false,
        data,
        message: responseData.message
      };
    } catch (error) {
      logger.error('Error fetching budget fiscal years:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error fetching budget years',
        error
      };
    }
  }

  async getBudgetOverview(companyId, params = {}) {
    try {
      const queryParams = new URLSearchParams();

      if (params.fiscalYearStart) {
        queryParams.append('fiscalYear', params.fiscalYearStart);
      }
      if (params.reportBasis) {
        queryParams.append('reportBasis', params.reportBasis);
      }

      const queryString = queryParams.toString();
      const url = `/company/${companyId}/budget-overview${queryString ? `?${queryString}` : ''}`;

      const response = await ApiService.get(url);
      const responseData = response.data || response;
      const data = responseData.data || responseData;

      return {
        success: responseData.success !== false,
        data,
        message: responseData.message
      };
    } catch (error) {
      logger.error('Error fetching budget overview:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error fetching budget overview report',
        error
      };
    }
  }
}

export default new BudgetOverviewService();

